import React from "react";
import { Button } from "components";
import { pocketMoniUrl } from "../../routes/routePaths";
import { logOut } from "utils/helper";
import { ImSwitch } from "react-icons/im";
import pocketMoniLogo from "../../assets/images/pocketmoni-logo.png";

const AuthHeader = ({ isLogOutHeader }) => {
  return (
    <>
      <div className="auth-header-container d-none d-xl-block">
        <div className="d-flex justify-content-between align-items-center auth-header mx-auto">
          <a href={pocketMoniUrl} target="_blank" rel="noopener noreferrer">
            <img src={pocketMoniLogo} width="100" alt="PocketMoni" />
          </a>

          {isLogOutHeader ? (
            <Button
              label="Logout"
              size="md"
              onClick={logOut}
              style={{ width: "fit-content" }}
            />
          ) : (
            <a
              href={`https://play.google.com/store/apps/details?id=com.pocketmoni.ui&hl=en`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button label="DOWNLOAD PocketMoni APP" size="md" />
            </a>
          )}
        </div>
      </div>

      {/* WORKS FOR MOBILE DEVICES */}
      {isLogOutHeader && (
        <div
          className="d-flex justify-content-end items-center text-danger bold mt-2 cursor-pointer d-xl-none"
          style={{ position: "relative", zIndex: 2 }}
          onClick={() => logOut()}
        >
          <ImSwitch /> &nbsp;{" "}
          <span style={{ marginTop: "-.2rem" }} onClick={() => logOut()}>
            Logout
          </span>
        </div>
      )}
    </>
  );
};

export default AuthHeader;
